import { HStack } from '@chakra-ui/react'
import ImageBox from 'components/common/ImageBox'
import IfopNavigation from 'components/markdown/components/IfopNavigation'
import { FC } from 'react'

const IfopDENavigation: FC = () => {
  return (
    <IfopNavigation
      title="Pesquisa Datafolha - Omens"
      links={[
        {
          to: '/problemas-de-erecao-o-grande-tabu/',
          content: (
            <HStack>
              <ImageBox alt="graph" src="/icons/open-iconic/svg/graph.svg" height="3rem" width="3rem" />
              <span className="ml-1">Ver o relatório</span>
            </HStack>
          )
        },
        {
          to: '/pesquisa-datafolha-problemas-de-erecao/',
          content: (
            <HStack>
              <ImageBox alt="book" src="/icons/open-iconic/svg/book.svg" height="3rem" width="3rem" />
              <span className="ml-1">Ver a pesquisa completa</span>
            </HStack>
          )
        },
        {
          to: '/problemas-de-erecao-o-grande-tabu-entrevista-joao-brunhara/',
          content: (
            <HStack>
              <ImageBox alt="chat" src="/icons/open-iconic/svg/chat.svg" height="3rem" width="3rem" />
              <span className="ml-1">Análise do João Brunhara</span>
            </HStack>
          )
        },
        {
          to: '/disfuncao-eretil',
          content: (
            <HStack>
              <ImageBox alt="medical" src="/icons/open-iconic/svg/medical-cross.svg" height="3rem" width="3rem" />
              <span className="ml-1">Tratamento para disfunção erétil</span>
            </HStack>
          )
        }
      ]}
    />
  )
}

export default IfopDENavigation
